import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Impressum.css';

function Impressum() {
  const { language } = useLanguage();

  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <h1>Impressum</h1>
        
        <section className="impressum-section">
          <h2>Angaben gemäß § 5 DDG</h2>
          <p>
            Jasmin Zentgraf<br />
            Unterreitnau 5<br />
            88131 Lindau<br />
            Deutschland
          </p>
        </section>

        <section className="impressum-section">
          <h2>Kontakt</h2>
          <p>
            E-Mail: <a href="mailto:just.travel.worldwide101@gmail.com">just.travel.worldwide101@gmail.com</a>
          </p>
        </section>

        <section className="impressum-section">
          <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>
            Jasmin Zentgraf<br />
            Unterreitnau 5<br />
            88131 Lindau<br />
            Deutschland
          </p>
        </section>

        <section className="impressum-section">
          <h2>Website</h2>
          <p>
            Just Travel – Reiseblog und Informationen rund ums preiswerte Reisen<br />
            <a href="https://www.just-travels.com" target="_blank" rel="noopener noreferrer">
              https://www.just-travels.com
            </a>
          </p>
        </section>

        <section className="impressum-section">
          <h2>Hinweis zu Affiliate-Links und Werbung</h2>
          <p>
            Auf dieser Website werden teilweise sogenannte Affiliate-Links verwendet. Wenn du über einen solchen Link eine Buchung oder einen Kauf tätigst, kann Just Travel eine Provision erhalten. Für dich entstehen dadurch keine Mehrkosten.
          </p>
          <p>
            Affiliate-Links und werbliche Inhalte sind nach Möglichkeit kenntlich gemacht.
          </p>
        </section>

        <section className="impressum-section">
          <h2>Haftung für Inhalte</h2>
          <p>
            Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden. Als Diensteanbieter bin ich gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG bin ich jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <section className="impressum-section">
          <h2>Haftung für Links</h2>
          <p>
            Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Bei Bekanntwerden von Rechtsverletzungen werden derartige Links umgehend entfernt.
          </p>
        </section>

        <section className="impressum-section">
          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind, soweit möglich, als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung der jeweiligen Autorin bzw. des jeweiligen Autors.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Impressum;
